/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningMatchType } from './InternalApiScreeningMatchType';
import {
    InternalApiScreeningMatchTypeFromJSON,
    InternalApiScreeningMatchTypeFromJSONTyped,
    InternalApiScreeningMatchTypeToJSON,
    InternalApiScreeningMatchTypeToJSONTyped,
} from './InternalApiScreeningMatchType';

/**
 * 
 * @export
 * @interface InternalApiScreeningFlowMatch
 */
export interface InternalApiScreeningFlowMatch {
    /**
     * 
     * @type {InternalApiScreeningMatchType}
     * @memberof InternalApiScreeningFlowMatch
     */
    type: InternalApiScreeningMatchType;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningFlowMatch
     */
    value?: number;
}



/**
 * Check if a given object implements the InternalApiScreeningFlowMatch interface.
 */
export function instanceOfInternalApiScreeningFlowMatch(value: object): value is InternalApiScreeningFlowMatch {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function InternalApiScreeningFlowMatchFromJSON(json: any): InternalApiScreeningFlowMatch {
    return InternalApiScreeningFlowMatchFromJSONTyped(json, false);
}

export function InternalApiScreeningFlowMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningFlowMatch {
    if (json == null) {
        return json;
    }
    return {
        
        'type': InternalApiScreeningMatchTypeFromJSON(json['type']),
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function InternalApiScreeningFlowMatchToJSON(json: any): InternalApiScreeningFlowMatch {
    return InternalApiScreeningFlowMatchToJSONTyped(json, false);
}

export function InternalApiScreeningFlowMatchToJSONTyped(value?: InternalApiScreeningFlowMatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': InternalApiScreeningMatchTypeToJSON(value['type']),
        'value': value['value'],
    };
}

